/** Textos del panel en español (idioma por defecto y referencia de la estructura). */
export const es = {
  meta: { title: 'Voxel Licencias · Administración' },
  common: {
    language: 'Idioma',
    cancel: 'Cancelar',
    save: 'Guardar',
    create: 'Crear',
    edit: 'Editar',
    delete: 'Eliminar',
    add: 'Añadir',
    close: 'Cerrar',
    copy: 'Copiar',
    copied: 'Copiado',
    loading: 'Cargando',
    previous: '← Anterior',
    next: 'Siguiente →',
    noResults: 'Sin resultados',
    range: '{from}–{to} de {total}',
    never: 'Nunca',
    none: 'Ninguno',
    noneF: 'Ninguna',
    name: 'Nombre',
    email: 'Email',
    notes: 'Notas',
    product: 'Producto',
    customer: 'Cliente',
    status: 'Estado',
    type: 'Tipo',
    date: 'Fecha',
    created: 'Alta',
    country: 'País',
    description: 'Descripción',
    days: '{n} días',
    allProducts: 'Todos los productos',
    networkError: 'No se puede conectar con la API',
    httpError: 'Error HTTP {status}',
  },
  nav: {
    appName: 'Licencias',
    appSub: 'Administración · Voxel',
    dashboard: 'Panel',
    licenses: 'Licencias',
    customers: 'Clientes',
    machines: 'Máquinas',
    products: 'Productos',
    operations: 'Operaciones',
    offline: 'Activación offline',
    audit: 'Auditoría',
    webhooks: 'Webhooks',
    reference: 'Referencia',
    manual: 'Manual de usuario',
    api: 'API (OpenAPI)',
    admin: 'Administrador',
    corporateSession: 'Inicio de sesión corporativo',
    localSession: 'Usuario local',
    logout: 'Cerrar sesión',
  },
  license: {
    type: { perpetual: 'Perpetua', subscription: 'Suscripción', trial: 'Prueba' },
    mode: { node_locked: 'Por puestos', floating: 'Flotante' },
    status: { active: 'Activa', suspended: 'Suspendida', revoked: 'Revocada', expired: 'Expirada' },
    activeDays: 'Activa · {days} d',
  },
  lastSeen: {
    never: 'Nunca',
    offline: 'Por fichero',
    offlineHelp: 'Activada por fichero el {date}: no se conecta al servidor',
    offlineOnlyHelp: 'Todos sus equipos se activaron por fichero: no se conectan al servidor',
  },
  login: {
    subtitle: 'Licencias · Panel de administración',
    corporate: 'Entrar con la cuenta corporativa',
    orLocal: 'o con usuario local',
    email: 'Email',
    password: 'Contraseña',
    submit: 'Entrar',
    noMethod: 'No hay ningún método de inicio de sesión configurado en la API, o no se puede contactar con ella.',
    customerQuestion: '¿Eres cliente y necesitas activar un equipo sin conexión?',
    portalLink: 'Portal de activación offline',
    completing: 'Completando inicio de sesión…',
    back: 'Volver al inicio de sesión',
    badCredentials: 'Email o contraseña incorrectos',
    oidcNotConfigured: 'OIDC no configurado',
  },
  dashboard: {
    title: 'Panel',
    subtitle: 'Estado general de las licencias de todos los productos',
    kpiActive: 'Licencias activas',
    kpiMachines: 'Máquinas activadas',
    kpiFloating: 'Sesiones flotantes en uso',
    kpiExpiring: 'Expiran en 30 días',
    recent: 'Activaciones recientes',
    seeAll: 'Ver todas',
    machine: 'Equipo',
    license: 'Licencia',
    when: 'Cuándo',
    noActivations: 'Aún no hay activaciones',
    expiring: 'Próximas a expirar',
    expires: 'Expira',
    noExpiring: 'Ninguna licencia expira en los próximos 30 días',
    inactive: 'Sin conexión en 30 días ({n})',
    inactiveHelp: 'Licencias activas que llevan más de 30 días sin conectarse: puede que el cliente no las esté usando.',
    noInactive: 'Todas las licencias activas se han conectado en los últimos 30 días',
    lastSeen: 'Última conexión',
    byProduct: 'Por producto',
    code: 'Código',
    active: 'Activas',
    total: 'Total',
  },
  licenses: {
    title: 'Licencias',
    subtitle: 'Busca, filtra y gestiona las licencias de todos los productos',
    exportCsv: 'Exportar CSV',
    new: '+ Nueva licencia',
    searchPlaceholder: 'Buscar por clave, cliente, email o notas…',
    anyStatus: 'Cualquier estado',
    anyType: 'Cualquier tipo',
    anyMode: 'Cualquier modalidad',
    anyExpiry: 'Cualquier expiración',
    expiringIn: 'Expiran en {n} días',
    anyEdition: 'Cualquier edición',
    colLastSeen: 'Última conexión',
    anyLastSeen: 'Cualquier conexión',
    inactiveFor: 'Sin conexión hace más de {n} días',
    neverActivated: 'Nunca activada',
    colKey: 'Clave',
    colUsage: 'Uso',
    colExpires: 'Expira',
    empty: 'No hay licencias que coincidan con los filtros',
    sessionsShort: '{n} ses.',
  },
  createLicense: {
    title: 'Nueva licencia',
    noCustomer: '— Sin cliente —',
    mode: 'Modalidad',
    modeNodeLocked: 'Por puestos (máquinas)',
    modeFloating: 'Flotante (concurrentes)',
    modeHelpFloating: 'Sesiones concurrentes con checkout/heartbeat',
    modeHelpNodeLocked: 'Máquinas activadas simultáneamente',
    seats: 'Puestos',
    sessions: 'Sesiones concurrentes',
    updatesUntil: 'Actualizaciones hasta',
    updatesHelp: 'Vacío = sin periodo de actualizaciones',
    duration: 'Duración (días)',
    maxVersion: 'Versión máxima',
    maxVersionHelp: 'Ej. "2" permite cualquier 2.x',
    noLimit: 'Sin límite',
    features: 'Features',
    noFeatures: 'El producto no tiene features definidas',
    edition: 'Edición',
    noEdition: '— Sin edición (a medida) —',
    editionHelp: 'Rellena las features y los límites de la edición; puedes ajustar las features',
    editionLimits: 'Incluye los límites de la edición: {limits}',
    notesPlaceholder: 'Nº de pedido, contacto…',
    notify: 'Enviar la clave por email al cliente',
    submit: 'Crear licencia',
  },
  licenseDetail: {
    back: '← Licencias',
    suspend: 'Suspender',
    suspendConfirm: '¿Suspender la licencia? Las apps dejarán de validar al conectarse.',
    reasonPrompt: 'Motivo (opcional)',
    reactivate: 'Reactivar',
    extend: 'Extender',
    changeSeats: 'Cambiar puestos',
    revoke: 'Revocar',
    revokeConfirm: 'La revocación es definitiva. ¿Revocar la licencia?',
    data: 'Datos',
    seats: 'Puestos',
    sessions: 'Sesiones concurrentes',
    inUse: '{used} de {seats} en uso',
    expires: 'Expira',
    updatesUntil: 'Actualizaciones hasta',
    noUpdatesPeriod: 'Sin periodo de actualizaciones',
    offlineGrace: 'Gracia offline',
    graceCustom: '{n} días (personalizado)',
    graceProduct: '{n} días (del producto)',
    reason: 'Motivo',
    createdAt: 'Creada',
    entitlements: 'Entitlements',
    subscription: 'Suscripción (Stripe)',
    openInStripe: 'Abrir en Stripe',
    subscriptionPlan: 'Plan',
    subscriptionState: 'Estado',
    subscriptionStatus: {
      active: 'Activa',
      trialing: 'En prueba',
      past_due: 'Pago pendiente',
      incomplete: 'Sin completar',
      unpaid: 'Impagada',
      canceled: 'Cancelada',
      incomplete_expired: 'Pago caducado',
      paused: 'En pausa',
    },
    subscriptionCanceling: 'No se renueva',
    subscriptionRenews: 'Próxima renovación',
    subscriptionEnds: 'Termina el',
    stripeCustomer: 'Cliente en Stripe',
    invoices: 'Facturas (Holded)',
    invoiceNumber: 'Número',
    invoiceKind: 'Tipo',
    invoiceAmount: 'Importe',
    invoiceKinds: { invoice: 'Factura', creditnote: 'Rectificativa' },
    invoiceStatus: {
      pending: 'En cola',
      issued: 'Emitida',
      draft: 'Borrador',
      failed: 'Fallida',
      skipped: 'Sin factura',
    },
    invoiceRetry: 'Reintentar',
    invoicesHelp:
      'Cada cobro de Stripe genera una factura en Holded (serie de las ventas en línea) y cada reembolso, una rectificativa. Si algo falla se reintenta solo; las fallidas quedan aquí para revisarlas y reintentarlas. «Borrador» es el modo de pruebas (HOLDED_APPROVE=false).',
    subscriptionHelp:
      'Comprada desde la aplicación. La licencia sigue sola a la suscripción: la edición cambia con el plan, la caducidad avanza con cada renovación (más el margen) y caduca si se cancela o no se paga. Los cambios de plan, de tarjeta y las cancelaciones se hacen en Stripe.',
    features: 'Features',
    limits: 'Límites',
    maxVersion: 'Versión máxima',
    noLimit: 'Sin límite',
    machines: 'Máquinas activadas ({n})',
    deactivatedList: 'Desactivadas ({n})',
    floatingSessions: 'Sesiones flotantes',
    colMachine: 'Máquina',
    colSince: 'Desde',
    colLastHeartbeat: 'Último heartbeat',
    colExpires: 'Caduca',
    noSessions: 'Sin sesiones',
    leaseInUse: 'En uso',
    leaseReturned: 'Devuelta',
    leaseExpired: 'Caducada',
    release: 'Liberar',
    history: 'Historial',
    colDevice: 'Equipo',
    colSystem: 'Sistema',
    colVersion: 'Versión',
    colActivated: 'Activada',
    colLastSeen: 'Última vez vista',
    noMachines: 'Ninguna máquina activada',
    offlineTag: 'offline',
    deactivatedAgo: 'Desactivada {when} ({reason})',
    reasonClient: 'por el cliente',
    reasonAdmin: 'por un admin',
    deactivate: 'Desactivar',
    deactivateConfirm: '¿Forzar la desactivación de {name}? Liberará el puesto.',
    thisMachine: 'esta máquina',
    extendTitle: 'Extender licencia',
    extendUpdatesTitle: 'Extender periodo de actualizaciones',
    daysToAdd: 'Días a añadir',
    daysToAddHelp: 'Se suman a la fecha actual de expiración ({date}) o a hoy si ya expiró',
    seatsTitle: 'Cambiar número de puestos',
    seatsHelp: 'Reducirlos no expulsa máquinas ya activadas; solo impide nuevas activaciones',
    entitlementsTitle: 'Editar entitlements',
    limitsJson: 'Límites numéricos (JSON)',
    limitsInvalid: 'Los límites deben ser un objeto JSON, p. ej. {"max_projects": 10}',
    maxVersionHelp: '"2" permite 2.x; vacío = sin límite',
    changesNote: 'Los cambios llegan a las apps en su siguiente validación online.',
    edition: 'Edición',
    lastSeen: 'Última conexión',
    noEdition: 'Sin edición (a medida)',
    editionHelp: 'Al elegir una edición se cargan sus features y límites; puedes ajustarlos antes de guardar',
    changeCustomer: 'Cambiar',
    customerTitle: 'Cambiar cliente',
    customerHelp: 'La clave y las máquinas activadas no cambian: la app sigue funcionando igual.',
    customerStripeNote: 'Las facturas de la suscripción se siguen emitiendo con los datos del cliente en Stripe.',
  },
  products: {
    title: 'Productos',
    subtitle: 'Aplicaciones de escritorio de Voxel con sus módulos y versiones',
    new: '+ Nuevo producto',
    colCode: 'Código',
    colGrace: 'Gracia offline',
    colRefresh: 'Revalidación',
    colTrial: 'Trial',
    everyHours: 'cada {n} h',
    no: 'No',
    empty: 'No hay productos',
    editTitle: 'Editar producto',
    newTitle: 'Nuevo producto',
    code: 'Código',
    codeHelp: 'Identificador que usan las apps (minúsculas, guiones)',
    graceDays: 'Gracia offline (días)',
    graceHelp: 'Cuánto puede funcionar la app sin conectar',
    refreshHours: 'Revalidar cada (horas)',
    leaseMinutes: 'Préstamo flotante (minutos)',
    leaseHelp: 'Sin heartbeat, la sesión se libera tras este tiempo',
    offlineDays: 'Validez activación offline (días)',
    allowTrial: 'Permitir periodo de prueba',
    trialDays: 'Días de prueba',
    back: '← Productos',
    licenseCount: '{n} licencias',
    viewLicenses: 'Ver licencias',
    deleteConfirm: '¿Eliminar el producto?',
    config: 'Configuración de licenciamiento',
    grace: 'Gracia offline',
    refresh: 'Revalidación',
    refreshEvery: 'cada {n} horas',
    lease: 'Préstamo flotante',
    leaseValue: '{n} minutos',
    offline: 'Activación offline',
    offlineValue: 'válida {n} días',
    trial: 'Periodo de prueba',
    trialValue: '{n} días por máquina',
    disabled: 'Deshabilitado',
    versions: 'Versiones publicadas',
    versionsHelp: 'Se usan para aplicar los periodos de actualizaciones de las licencias perpetuas.',
    colVersion: 'Versión',
    colPublished: 'Publicada',
    deleteVersionConfirm: '¿Eliminar la versión {v}?',
    publishDate: 'Fecha de publicación',
    addVersion: 'Añadir versión',
    features: 'Features / módulos',
    colName: 'Nombre',
    colDefault: 'Por defecto',
    colInTrial: 'En trial',
    noFeatures: 'Sin features',
    deleteFeatureConfirm: '¿Eliminar la feature {code}?',
    featureCodePlaceholder: 'codigo-feature',
    featureNamePlaceholder: 'Nombre visible',
    editFeatureTitle: 'Editar feature',
    featureCodeHelp: 'Es lo que comprueba la app y lo que guardan las licencias: no se puede cambiar. Para otro código, crea una feature nueva.',
    addFeature: 'Añadir feature',
    editions: 'Ediciones',
    editionsHelp:
      'Niveles comerciales del producto (Básica, Pro…). Son plantillas: al crear una licencia se copian sus features y límites, y la app ve la edición en el certificado.',
    newEdition: '+ Nueva edición',
    newEditionTitle: 'Nueva edición',
    editEditionTitle: 'Editar edición',
    noEditions: 'Sin ediciones: las licencias se crean con las features por defecto del producto',
    colLimits: 'Límites',
    colLicenses: 'Licencias',
    editionCodeHelp: 'Va en el certificado y es lo que comprueba la app; no se puede cambiar después',
    order: 'Orden',
    orderHelp: 'De menor a mayor nivel',
    editionChangesNote: 'Los cambios se aplican a las licencias que se creen a partir de ahora; las existentes no cambian.',
    deleteEditionConfirm: '¿Eliminar la edición {name}?',
  },
  customers: {
    title: 'Clientes',
    subtitle: 'Organizaciones y usuarios finales',
    new: '+ Nuevo cliente',
    searchPlaceholder: 'Buscar por nombre, email, CIF o referencia…',
    colTaxId: 'CIF/NIF',
    empty: 'No hay clientes',
    editTitle: 'Editar cliente',
    newTitle: 'Nuevo cliente',
    legalName: 'Nombre / razón social',
    contactEmail: 'Email de contacto',
    taxId: 'CIF / NIF',
    externalRef: 'Referencia externa',
    externalRefHelp: 'ID en CRM / facturación',
    back: '← Clientes',
    newLicense: '+ Nueva licencia',
    data: 'Datos',
    users: 'Usuarios finales',
    noUsers: 'Sin usuarios',
    deleteUserConfirm: '¿Eliminar el usuario?',
    emailPlaceholder: 'email@cliente.com',
    licenses: 'Licencias ({n})',
    noLicenses: 'Sin licencias',
    colKey: 'Clave',
    colExpires: 'Expira',
    colLastSeen: 'Última conexión',
  },
  machines: {
    title: 'Máquinas',
    subtitle: 'Equipos activados en todas las licencias. Solo se guarda un hash del hardware, nunca datos en claro.',
    searchPlaceholder: 'Buscar por nombre de equipo, fingerprint, clave o cliente…',
    active: 'Activas',
    inactive: 'Desactivadas',
    all: 'Todas',
    colMachine: 'Equipo',
    colLicense: 'Licencia',
    colOs: 'SO / versión',
    colLastSeen: 'Última vez vista',
    deactivatedAgo: 'Desactivada {when}',
    deactivateConfirm: '¿Forzar la desactivación de {name}?',
  },
  audit: {
    title: 'Auditoría',
    subtitle: 'Registro de todas las acciones administrativas y de las aplicaciones cliente',
    allActions: 'Todas las acciones',
    anyActor: 'Cualquier actor',
    userPlaceholder: 'Usuario (email)…',
    from: 'Desde',
    to: 'Hasta',
    colActor: 'Actor',
    colAction: 'Acción',
    colEntity: 'Entidad',
    colDetails: 'Detalles',
    empty: 'Sin registros',
    group: {
      license: 'Licencias',
      activation: 'Activaciones',
      floating: 'Flotantes',
      trial: 'Pruebas',
      product: 'Productos',
      edition: 'Ediciones',
      customer: 'Clientes',
      webhook: 'Webhooks',
    },
    actor: { admin: 'Admin', client: 'App', system: 'Sistema' },
    actorFilter: { admin: 'Administradores', client: 'Aplicaciones', system: 'Sistema' },
    action: {
      'license.created': 'Licencia creada',
      'license.updated': 'Licencia modificada',
      'license.revoked': 'Licencia revocada',
      'license.suspended': 'Licencia suspendida',
      'license.reactivated': 'Licencia reactivada',
      'license.extended': 'Licencia extendida',
      'license.seats_changed': 'Puestos cambiados',
      'license.expired': 'Licencia expirada',
      'activation.created': 'Máquina activada',
      'activation.deactivated': 'Máquina desactivada (cliente)',
      'activation.force_deactivated': 'Máquina desactivada (admin)',
      'activation.offline': 'Activación offline',
      'floating.checkout': 'Sesión flotante tomada',
      'floating.checkin': 'Sesión flotante devuelta',
      'floating.force_checkin': 'Sesión flotante liberada (admin)',
      'trial.started': 'Prueba iniciada',
      'product.created': 'Producto creado',
      'product.updated': 'Producto modificado',
      'product.deleted': 'Producto eliminado',
      'feature.created': 'Feature creada',
      'feature.updated': 'Feature modificada',
      'feature.deleted': 'Feature eliminada',
      'edition.created': 'Edición creada',
      'edition.updated': 'Edición modificada',
      'edition.deleted': 'Edición eliminada',
      'version.created': 'Versión registrada',
      'version.deleted': 'Versión eliminada',
      'customer.created': 'Cliente creado',
      'customer.updated': 'Cliente modificado',
      'customer.deleted': 'Cliente eliminado',
      'customer_user.created': 'Usuario añadido',
      'customer_user.deleted': 'Usuario eliminado',
      'webhook.created': 'Webhook creado',
      'webhook.updated': 'Webhook modificado',
      'webhook.deleted': 'Webhook eliminado',
    },
  },
  offline: {
    title: 'Activación offline',
    subtitle: 'Activa equipos que no tienen conexión a internet mediante ficheros firmados',
    invalidJson: 'El fichero no contiene JSON válido. Sube el fichero .req generado por la aplicación.',
    notRequest: 'El fichero no es una solicitud de activación offline de Voxel.',
    dropTitle: 'Arrastra aquí el fichero de solicitud',
    dropHint: 'o haz clic para seleccionarlo (.req)',
    done: 'Activación generada.',
    doneDetail: 'Se ha descargado {file} para el equipo {machine} (licencia {key}, emitida {date}). Cópialo al equipo sin conexión e impórtalo desde la aplicación.',
    unknownMachine: 'sin nombre',
    downloadAgain: 'Descargar de nuevo',
    fileSuffix: 'activacion',
    howTitle: 'Cómo funciona',
    step1: 'En el equipo sin conexión, la aplicación genera un fichero de solicitud (.req).',
    step2: 'Llévalo a un equipo con internet y súbelo aquí.',
    step3: 'Se descarga un fichero de respuesta firmado (.lic): cópialo al equipo e impórtalo en la aplicación.',
    howNote: 'Los clientes también pueden hacerlo sin cuenta en el portal de autoservicio. La activación ocupa un puesto de la licencia y queda registrada en la auditoría. Las licencias flotantes necesitan conexión.',
    portalLink: 'Abrir el portal de autoservicio',
    portalTitle: 'Activación sin conexión · Portal de autoservicio',
  },
  webhooks: {
    title: 'Webhooks',
    subtitle: 'Notificaciones salientes firmadas con HMAC-SHA256 para integrar tienda, CRM o facturación',
    new: '+ Nuevo webhook',
    secretTitle: 'Secreto de firma',
    secretNote: '(solo se muestra ahora; guárdalo en el sistema receptor):',
    verification: 'Verificación:',
    verificationDetail: 'contra la cabecera',
    colUrl: 'URL',
    colEvents: 'Eventos',
    allEvents: 'Todos',
    enabled: 'Activo',
    paused: 'Pausado',
    empty: 'No hay webhooks configurados',
    deliveries: 'Entregas',
    test: 'Probar',
    pause: 'Pausar',
    resume: 'Activar',
    deleteConfirm: '¿Eliminar el webhook?',
    newTitle: 'Nuevo webhook',
    url: 'URL de destino',
    events: 'Eventos',
    eventsHelp: 'Sin selección = todos los eventos',
    deliveriesTitle: 'Últimas entregas',
    colEvent: 'Evento',
    colAttempts: 'Intentos',
    noDeliveries: 'Sin entregas',
    delivery: { delivered: 'Entregado', pending: 'Pendiente', failed: 'Fallido' },
  },
  manual: {
    title: 'Manual de usuario',
    subtitle: 'Guía del panel de administración y de las tareas habituales de soporte',
    print: 'Imprimir',
    downloadWord: 'Descargar en Word',
    contents: 'Contenido',
  },
  /** Mensajes por código de error de la API (si falta, se muestra el mensaje del servidor). */
  errors: {
    network_error: 'No se puede conectar con la API',
    unauthorized: 'Sesión caducada o no válida. Vuelve a iniciar sesión.',
    forbidden: 'No tienes permiso para esta acción',
    not_found: 'No encontrado',
    rate_limited: 'Demasiadas peticiones; espera unos segundos',
    invalid_license: 'Clave de licencia no válida',
    product_mismatch: 'La licencia pertenece a otro producto',
    license_suspended: 'La licencia está suspendida',
    license_revoked: 'La licencia ha sido revocada',
    license_expired: 'La licencia ha expirado',
    version_not_allowed: 'La licencia no permite esta versión de la aplicación',
    seat_limit_reached: 'La licencia no tiene puestos libres',
    no_floating_seats: 'Todas las sesiones flotantes están en uso',
    not_activated: 'La máquina no está activada',
    not_floating: 'Las licencias flotantes necesitan conexión: no admiten activación offline',
    trial_already_used: 'Esta máquina ya consumió su periodo de prueba',
    trial_not_available: 'Este producto no ofrece periodo de prueba',
    invalid_offline_request: 'El fichero no es una solicitud de activación offline válida',
    internal_error: 'Error interno del servidor',
  },
};
